module.exports = __webpack_public_path__ + "img/remove.4caa18dd.jpg";